export enum IterableDistanceUnit {
  kilometers = 'km',
  miles = 'mi',
}

export type GeoLocation = { lon: number; lat: number };
export type GeoDistance = { distance: number; unit: IterableDistanceUnit };
